import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import axios from "axios"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useHistory } from "react-router-dom"
import { error } from "toastr"

const DuplicateTable = ({ data }) => {
  console.log("data", data)
  return (
    <Table className="text-center">
      <tr>
        <th>Project Ref</th>
        <th>Survey No</th>
      </tr>
      {data.map((item, i) => (
        <tr key={i}>
          <td>{item.ProjectRef}</td>
          <td>{item.ArealDecisionNumber}</td>
        </tr>
      ))}
    </Table>
  )
}

const ImportedDataResult = ({
  importedDataResultToggle,
  insertedDataResult,
  setInsertedDataResult,
}) => {
  const history = useHistory()

  const [modal, setmodal] = useState(true)
  const modalToggle = () => {
    importedDataResultToggle()
    setInsertedDataResult(null)
  }
  const onClose = () => {
    importedDataResultToggle()
    setInsertedDataResult(null)
  }

  // ***************************** Accordion *************************************
  const [open, setOpen] = useState("")
  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  return (
    <Modal isOpen={modal} toggle={modalToggle} className="modal-lg">
      <ModalHeader>
        Imported Data Duplicates
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody>
        <div>
          <Accordion flush open={open} toggle={toggle}>
            {insertedDataResult.map((item, i) => (
              <AccordionItem key={i}>
                <AccordionHeader targetId={`duplicate-${i}`}>
                  {item.duplicates[0].ProjectRef}
                </AccordionHeader>

                <AccordionBody accordionId={`duplicate-${i}`}>
                  <DuplicateTable data={item.duplicates} />
                </AccordionBody>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ImportedDataResult
